<script>
import Auth from "@/pages/layouts/auth.vue";
import TwoFactor from "@/pages/profile/two-factor.vue";

export default {
  components: {TwoFactor, Auth},
  props: {
    qrImage: {
      type: String,
      required: true,
    },
    secret: {
      type: String,
      required: true,
    },
  }
}
</script>

<template>
  <Auth title="2FA authenticatie">
    <TwoFactor
        :secret="secret"
        :qr-image="qrImage"
        :two-fa-enabled="false"
        :showTitle="false"
    />
  </Auth>
</template>